import React from "react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import AppCard from "../components/AppCard";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import { applications } from "../mock";

export default function Applications() {
  return (
    <div className="bg-white" data-testid="applications-page">
      <PageBanner
        title="Uygulamalar"
        subtitle="Konstrüksiyondan basınçlı kaplara, köprülerden silolara geniş bir yelpazede çözümler."
        breadcrumbs={[{ label: "Uygulamalar" }]}
        image="/images/slider/slider1.jpg"
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal className="mb-16">
            <SectionHeading
              eyebrow="Hizmetlerimiz"
              title="Çelikte Uçtan Uca Çözümler"
              subtitle="Dünya standartlarında ve %100 izlenebilirlik kalite politikası ile imalat ve montaj."
              className="max-w-xl"
            />
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-line">
            {applications.map((app, i) => (
              <Reveal key={app.slug} delay={(i % 3) * 110}>
                <AppCard app={app} index={i} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <QuoteBand />
    </div>
  );
}
